<template>
	<div class="container__registers">
		<ContentHeader>
			<SubHeader :title="title" />
		</ContentHeader>
		<ContentBody>
			<Card>
				<router-view @atualizarTitulo="atualizaTitulo" />
			</Card>
		</ContentBody>
	</div>
</template>

<script>
import Card from '../../components/Card/Card'
import ContentBody from '../../components/ContentBody/ContentBody'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import SubHeader from '../../components/SubHeader/SubHeader'
import i18n from '../../VueI18n'

export default {
	components: { Card, ContentBody, ContentHeader, SubHeader },
	data() {
		return {
			activeRoute: '',
			customTitle: null,
			labelAndLinkName: [
				{
					label: 'Integração SAP',
					linkName: 'integracao-SAP',
				},
				{
					label: i18n.t('apiKeys'),
					linkName: 'apikey',
				},
			],
		}
	},
	computed: {
		title() {
			
			if (this.customTitle) {
				return this.customTitle
			}
			
			const matchedRoute = this.labelAndLinkName.find((f) => f.linkName === this.activeRoute)
			if (matchedRoute) {
				return `Integrações / ${matchedRoute.label}`
			}
			return 'Integrações'
		},
	},
	watch: {
		$route(to) {
			this.activeRoute = to.name
			this.customTitle = null // Limpa o título customizado ao mudar de rota
		},
	},
	created() {
		this.activeRoute = this.$route.name
	},
	methods: {
		atualizaTitulo(novoTitulo) {
			
			this.customTitle = novoTitulo
		},
	},
}
</script>

<style scoped></style>
